<template>
    <b-row class="invoice-details">
        <b-col xl="6" md="6" sm="6">
            <b-table-simple borderless v-if="inputInvoice">
                <b-tbody>
                    <input
                        type="hidden"
                        name="invoice-id"
                        :value="invoice.id"
                    />
                    <b-tr class="row">
                        <b-th class="col-4">Client:</b-th>
                        <b-td
                            class="col-8"
                            v-if="
                                ![
                                    BILLINGS.INVOICE.TYPE_PAID,
                                    BILLINGS.INVOICE.TYPE_WRITEOFF,
                                    BILLINGS.INVOICE.TYPE_REOPENED
                                ].includes(inputInvoice.invoice_status.value) &&
                                tabCount.payment_count == 0
                            "
                        >
                            <vet-select
                                id="client_id"
                                v-model="inputInvoice.client"
                                v-validate="'required'"
                                :class="{
                                    'border-danger': errors.has('client_id')
                                }"
                                :show-menu="false"
                                module="client"
                                placeholder="Client name (required)"
                                name="client_id"
                            />
                        </b-td>
                        <b-td class="col-8" v-else>
                            <span v-if="invoice.client">
                                <client-name
                                    :client="invoice.client"
                                    :text="invoice.client.display_name"
                                />
                            </span>
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Account Balance:</b-th>
                        <b-td class="col-8">
                            {{ _toCurrency(invoice.account_balance) }}
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Status:</b-th>
                        <b-td
                            class="col-8"
                            v-if="
                                tabCount.returns_count == 0 &&
                                _hasAccess('billing.invoice.add.status')
                            "
                        >
                            <select
                                id="status"
                                v-model="inputInvoice.invoice_status"
                                class="form-control"
                            >
                                <option
                                    v-for="status in invoiceStatusList"
                                    :key="status.value"
                                    :value="status"
                                    >{{ status.label }}</option
                                >
                            </select>
                        </b-td>
                        <b-td class="col-8" v-else>
                            <span v-if="invoice.status">
                                {{ invoice.status_label }}
                            </span>
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Payment Terms:</b-th>
                        <b-td
                            class="col-8"
                            v-if="
                                ![
                                    BILLINGS.INVOICE.TYPE_PAID,
                                    BILLINGS.INVOICE.TYPE_WRITEOFF,
                                    BILLINGS.INVOICE.TYPE_REOPENED
                                ].includes(inputInvoice.invoice_status.value)
                            "
                        >
                            <select
                                id="paymentTerm"
                                v-model="inputInvoice.payment_term"
                                class="form-control"
                            >
                                <option
                                    v-for="term in paymentTerms"
                                    :key="term.id"
                                    :value="term"
                                    >{{ term.value }}</option
                                >
                            </select>
                        </b-td>
                        <b-td class="col-8" v-else>
                            <span v-if="invoice.payment_term_label">
                                {{ invoice.payment_term_label }}
                            </span>
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Created:</b-th>
                        <b-td
                            class="col-8"
                            v-if="
                                ![
                                    BILLINGS.INVOICE.TYPE_PAID,
                                    BILLINGS.INVOICE.TYPE_WRITEOFF,
                                    BILLINGS.INVOICE.TYPE_REOPENED
                                ].includes(inputInvoice.invoice_status.value)
                            "
                        >
                            <date-picker
                                id="start"
                                :config="datePickerOptions"
                                v-model="inputInvoice.start"
                                v-validate="'required'"
                                :class="{
                                    'border-danger': errors.has('start')
                                }"
                                class="form-control"
                                placeholder="Create Date (required)"
                                name="start"
                            ></date-picker>
                        </b-td>
                        <b-td class="col-8" v-else>
                            {{ _carbonDateDisplay(invoice.start) }}
                            <template v-if="invoice.estimates.length > 0">
                                (
                                <span
                                    v-for="(est, i) in invoice.estimates"
                                    :key="est.index"
                                >
                                    <estimate-link
                                        :estimate="est"
                                        :useRouter="USE_ESTIMATE_MODULE_VUE"
                                        :text="`Est #${est.index}`"
                                    />
                                    {{
                                        invoice.estimates.length != i + 1
                                            ? ", "
                                            : ""
                                    }} </span
                                >)
                            </template>
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Location:</b-th>
                        <b-td class="col-8" v-if="checkLocationService()">
                            <template
                                v-if="
                                    ![
                                        BILLINGS.INVOICE.TYPE_PAID,
                                        BILLINGS.INVOICE.TYPE_WRITEOFF,
                                        BILLINGS.INVOICE.TYPE_REOPENED
                                    ].includes(
                                        inputInvoice.invoice_status.value
                                    )
                                "
                            >
                                <select
                                    id="location"
                                    v-model="inputInvoice.location"
                                    class="form-control"
                                >
                                    <option
                                        :value="inClinic"
                                        v-if="$root.setting.location == 2"
                                        >In Clinic</option
                                    >
                                    <option
                                        v-for="location in locations"
                                        :key="location.id"
                                        :value="location"
                                        >{{ location.name }}
                                        {{ location.address }}
                                    </option>
                                </select>
                            </template>
                            <template v-else>
                                {{ invoice.location_name }}
                            </template>
                        </b-td>
                        <b-td class="col-8" v-else>
                            {{ invoice.ismobile ? "At Client" : "In Clinic" }}
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Notes: </b-th>
                        <b-td class="col-8">
                            <editable
                                name="note"
                                v-model="inputInvoice.note"
                                placeholder="Note (optional)"
                                :defaultHeight="64"
                            ></editable>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-col>

        <!-- 2nd column -->
        <b-col xl="6" md="6" sm="6">
            <InvoiceDisplayDetails />
        </b-col>
    </b-row>
</template>

<script>
/**
 * @name CreateUpdateInvoice
 * @description null
 * Conditions: Must check permission to edit item
 * @see apps/application/views/staff/billing/invoice/invoice/create_update.php
 */

import { forEach, clone, includes, find } from "lodash";
import "vue-simple-suggest/dist/styles.css";
import InvoiceGeneralService from "@/services/invoice/invoice-general.js";
import Client from "@/services/client";
import ReferenceServices from "@/services/reference";
import vetSelect from "@/module/commons/vet-select.vue";
import BILLINGS from "@/constants/billings";
import InvoiceDisplayDetails from "@/components/invoice/invoice-display-details";
import ClientName from "@/components/commons/client-name";
import EstimateLink from "@/components/commons/estimate-link";
import Editable from "@/components/elements/editable-textarea";

export default {
    mixins: [],
    components: {
        vetSelect,
        ClientName,
        EstimateLink,
        InvoiceDisplayDetails,
        Editable
    },
    props: {
        invoice: {
            type: Object,
            default: null,
            require: true
        },
        tabCount: {
            type: Object,
            require: true
        }
    },
    data() {
        return {
            BILLINGS,
            instructionCount: {
                count: 200,
                error: false,
                model: "instruction"
            },
            formError: [],
            defaultDisabled: true, // when open, default disabled, enabled when the form is ready to avoid user make a change when internet slow
            componentKey: 1,
            inputInvoice: null,
            datePickerOptions: {
                format: "DD/MM/YYYY"
            },
            paymentTerms: [],
            locations: [],
            invoiceStatusList: [
                { value: 5, label: "Locked" },
                { value: 1, label: "Open" },
                { value: 2, label: "Paid" },
                { value: 6, label: "Reopened" }
            ],
            inClinic: {
                id: 1,
                name: "In Clinic",
                address: null
            },
            serviceLocation: {
                mobile: 1,
                mobileAndOnPremise: 2
            }
        };
    },
    watch: {
        "inputInvoice.client": {
            async handler(newData, oldData) {
                let self = this;
                if (oldData === undefined) return;

                // add client check
                if (newData) {
                    let validClient = await InvoiceGeneralService.checkClient({
                        id: newData.id,
                        invoice_id: this.invoice.id
                    });

                    if (!validClient.switch_client) {
                        this._message(validClient.message, "danger");
                        this.inputInvoice.client = oldData;
                        return;
                    }
                }

                this.$store.commit("billing/setDirty", true);

                // update location list
                if (newData) {
                    this.getLocations(newData.id);
                } else if (newData === null) {
                    self.locations = [];
                    self.inputInvoice.location = null;
                }
            }
        },
        "inputInvoice.start": {
            async handler(newData, oldData) {
                if (!oldData) return;
                this.$store.commit("billing/setDirty", true);
            }
        },
        "inputInvoice.invoice_status": {
            handler(newData, oldData) {
                if (
                    this.invoice.status == BILLINGS.INVOICE.TYPE_WRITEOFF &&
                    oldData
                ) {
                    // set show modal to true if user want to change status from write off thus will trigger a modal
                    this.$emit(
                        "saving-confirmation",
                        newData.value != this.invoice.status
                    );
                }
            }
        }
    },
    mounted() {
        this.datePickerOptions.format = this.getDateFormat();
        this.prepareInvoiceStatus();
        this.getPaymentTerms();
        this.getLocations(this.invoice.client_id);
        this.inputInvoice = {
            client: this.invoice.client,
            invoice_status: find(
                this.invoiceStatusList,
                status => status.value == this.invoice.status
            ),
            start: this._carbonDateDisplay(this.invoice.start),
            note: this.invoice.note == null ? "" : this.invoice.note,
            payment_term: this.invoice.payment_term
        };
    },
    methods: {
        prepareInvoiceStatus() {
            // --- remove type PAID if needed and add WRITTEN OFF
            if (
                this.invoice.balance > 0 ||
                this.invoice.status == BILLINGS.INVOICE.TYPE_WRITEOFF
            ) {
                if (this.invoice.status != BILLINGS.INVOICE.TYPE_PAID) {
                    this.invoiceStatusList = this.invoiceStatusList.filter(
                        inStatus =>
                            inStatus.value !== BILLINGS.INVOICE.TYPE_PAID
                    );
                }
                if (this.invoice.status == BILLINGS.INVOICE.TYPE_WRITEOFF)
                    this.invoiceStatusList.push({
                        value: BILLINGS.INVOICE.TYPE_WRITEOFF,
                        label: "Written Off"
                    });
            }
            // --- control invoice status options
            forEach(clone(this.invoiceStatusList), status => {
                switch (this.invoice.status) {
                    case 1:
                        if (status.value == BILLINGS.INVOICE.TYPE_REOPENED)
                            this.invoiceStatusList = this.invoiceStatusList.filter(
                                inStatus => inStatus.value !== status.value
                            );
                        break;
                    case 5:
                        // --- if lock but not yet paid
                        if (this.invoice.balance == this.invoice.amount) {
                            if (status.value == BILLINGS.INVOICE.TYPE_REOPENED)
                                this.invoiceStatusList = this.invoiceStatusList.filter(
                                    inStatus => inStatus.value !== status.value
                                );
                        } else {
                            if (status.value == BILLINGS.INVOICE.TYPE_OPEN)
                                this.invoiceStatusList = this.invoiceStatusList.filter(
                                    inStatus => inStatus.value !== status.value
                                );
                        }
                        break;
                    case 2:
                    case 3:
                        if (status.value == BILLINGS.INVOICE.TYPE_OPEN)
                            this.invoiceStatusList = this.invoiceStatusList.filter(
                                inStatus => inStatus.value !== status.value
                            );
                        break;
                    default:
                        break;
                }
            });
        },
        async getLocations(clientId) {
            await Client.getLocations(clientId).then(response => {
                this.locations = response.resources;
                this.setSelectedLocation();
            });
        },
        setSelectedLocation() {
            let location = this.invoice.location_id;
            if (location) {
                this.locations.forEach(element => {
                    if (location == element.id) {
                        this.inputInvoice.location = element;
                    }
                });
            } else {
                this.inputInvoice.location = this.inClinic;
            }
        },
        async getPaymentTerms() {
            await ReferenceServices.getPaymentTerms().then(res => {
                if (res.message.code == 200) {
                    this.paymentTerms = res.resources;
                    this.setPaymentTerm();
                }
            });
        },
        setPaymentTerm() {
            let paymentTerm = this.invoice.payment_term;
            if (paymentTerm) {
                this.paymentTerms.forEach(element => {
                    if (paymentTerm == element.id) {
                        this.inputInvoice.payment_term = element;
                    }
                });
            }
        },
        /////////////////
        // FLOW SAVING //
        /////////////////
        /**
         * @method isValid
         * @description To check is form dont have any error
         * @return  {Promise}
         */
        async checkFormIsValid() {
            let valid = await this.$validator.validateAll();
            if (!valid) {
                return false;
            }

            return true;
        },
        /**
         * @method proceedSave
         * @description
         */
        async proceedSave() {
            let startDate = this._fromDateCarbon(this.invoice.start).setZone(
                this._timeZone
            );
            let currlocation = this.inputInvoice.location ?? this.inClinic;
            let location = currlocation.id;
            if ("type" in currlocation)
                location = `[${currlocation.type}]${location}`;

            // PARAMS
            let details = {
                edit: true,
                id: this.invoice.id,
                cid: this.inputInvoice.client.id,
                date: this._carbonDateDisplay(this.invoice.start),
                start_time: startDate.toFormat("h:mm a"),
                start: this.inputInvoice.start,
                expire: this._carbonDateDisplay(this.invoice.expire),
                client: this.inputInvoice.client.label,
                location_id: location,
                note: this.inputInvoice.note,
                flag: 0,
                status: this.invoice.status,
                payment_term: this.inputInvoice.payment_term.id,
                invoice_status: this.inputInvoice.invoice_status.value,
                late_fees_credit: undefined
            };

            var formData = new FormData();

            for (var key in details) {
                formData.append(key, details[key]);
            }

            if (details.date != details.start) {
                const date = this._fromDateStrToDateTime(details.start, true);

                this.$store.dispatch("checkBillingLock", {
                    date,
                    onProceed: () => this.save(formData),
                    onError: message => this._message(message, "danger")
                });
            } else {
                this.save(formData);
            }
        },
        save(formData) {
            let generalErrorMsg = "Error: Unable to save";

            InvoiceGeneralService.updateInvoice(formData)
                .then(res => {
                    if (res) {
                        this._message("Invoice saved");
                        this.$emit("saved", {
                            success: true
                        });
                        this.$store.commit("billing/setDirty", false);
                    } else {
                        throw new Error(generalErrorMsg);
                    }
                })
                .catch(e => {
                    this._message(generalErrorMsg, "danger");

                    this.$emit("saved", {
                        success: false
                    });
                });
        },

        /**
         * @method is_dirty
         * @description To check if form has made any changes and
         * if have, system will prompt confirmation when user try to change page
         * @return  {Boolean}
         */
        is_dirty() {
            return Object.keys(this.fields).some(key => this.fields[key].dirty);
        },
        checkLocationService() {
            // if setting is set to on premise, location will be hidden
            return (
                this.$root.setting &&
                includes(
                    [
                        this.serviceLocation.mobile,
                        this.serviceLocation.mobileAndOnPremise
                    ],
                    this.$root.setting.location
                )
            );
        }
    }
};
</script>

<style type="text/css" lang="scss" scoped>
.invoice-details th,
.invoice-details td {
    padding: 0px !important;
    line-height: 35px !important;
}
.invoice-details tr {
    padding-left: 1.5rem !important;
}
.custom-select {
    display: block;
}

textarea.form-control {
    min-height: 75px !important;
}

.no-opt {
    padding: 0 5px;
}
</style>
<style>
/**
* @see https://github.com/riophae/vue-treeselect/issues/137 
*/
.vue-treeselect.treeselect-invalid:not(.vue-treeselect--open)
    .vue-treeselect__control {
    border-color: #b94a48 !important;
    background-color: #ffdddd !important;
}
</style>
